import React from "react"
import Cabecalho from "../Cabecalho"
import { Loading } from "../RegistradorDePedidos"
import { IntegracaoOpenDeliveryForm } from "./components/IntegracaoOpenDeliveryForm"

export function Index() {
    return (
        <>
            <Cabecalho pagina="Integração Open Delivery" />
            <Loading />
            <IntegracaoOpenDeliveryForm />
        </>
    )
}
